import React from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import TicketList from "../components/TicketList";

function Tickets() {
  const { t } = useTranslation();
  const location = useLocation();
  const { golfNGrow } = location.state || {};

  return (
    <div>
      <section>
        <div className="space-y-4 app-main-container">
          <p className="text-xl font-bold text-center sm:text-2xl text-app-blue-3 app-animation-translate-start">
            {t("ticketPrice")}
          </p>
          <p className="text-xl font-bold text-center sm:text-2xl app-animation-translate-start">
            {t("selectTicket")}
          </p>
        </div>
      </section>
      <section>
        <div className="space-y-4 app-main-container">
          <TicketList golfNGrow={golfNGrow}/>
        </div>
      </section>
    </div>
  );
}

export default Tickets;
